namespace AgerLMS.LMS {
    export interface OrderItemListRequest extends Serenity.ListRequest {
        PurchasedWebinarsPage?: boolean;
        PurchasedProductsPage?: boolean;
    }
}
